import { API_ENDPOINTS } from "./../../shared/services/api/api-endpoints";
import { Component, Inject, inject, PLATFORM_ID } from "@angular/core";
import { LeftMenuComponent } from "../../shared/components/left-menu/left-menu.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogPositionClass } from "../../shared/enums/dialogs.enum";
import { RouterOutlet } from "@angular/router";

import Swal from "sweetalert2";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { WebSocketsService } from "../../shared/services/web-sockets.service";
import { NotificationService } from "../../shared/services/notifications-service";
import { NotificationBellComponent } from "../../shared/components/notification-bell/notification-bell.component";
import { ApiService } from "../../shared/services/api/api.service";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-customer",
  imports: [
    RouterOutlet,
    LeftMenuComponent,
    CommonModule,
    NotificationBellComponent,
  ],
  templateUrl: "./customer.component.html",
  styleUrl: "./customer.component.scss",
  standalone: true,
})
export class CustomerComponent {
  dialog: MatDialog = inject(MatDialog);
  notificationCount: number = 0;
  notificationMessages: any[] = [];
  isOpen: boolean = false;

  assetUrl = environment.assetBaseUrl;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private apiService: ApiService,
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
    }
  }

  readonly menuItems = [
    {
      label: "Overview",
      link: "overview",
      icon: this.assetUrl + "icons/menu-home.svg",
      alt: "Home icon",
    },
    {
      label: "Your Appointments",
      link: "appointments",
      icon: this.assetUrl + "icons/menu-list.svg",
      alt: "Appointment icon",
    },
    {
      label: "Your Faves",
      link: "favorites",
      icon: this.assetUrl + "icons/menu-heart.svg",
      alt: "Favorite icon",
    },
    {
      label: "Promo Codes",
      link: "promo-codes",
      icon: this.assetUrl + "icons/menu-ticket.svg",
      alt: "Promo Codes icon",
    },
    {
      label: "Account Settings",
      link: "account",
      icon: this.assetUrl + "icons/menu-account.svg",
      alt: "Account Settings icon",
    },
  ];

  openMenuDialog(): void {
    this.dialog.open(LeftMenuComponent, {
      panelClass: DialogPositionClass.left,
      data: { items: this.menuItems },
    });
  }
}
